import React from "react";
import Typography from "@mui/material/Typography";
import Accordion, { AccordionProps } from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails, {
  AccordionDetailsProps,
} from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function SFAccordion({
  header,
  children,
  accordionDetailsProps,
  ...props
}: {
  header: React.ReactNode;
  children: React.ReactNode;
  accordionDetailsProps?: AccordionDetailsProps;
} & AccordionProps) {
  return (
    <Accordion
      {...props}
      sx={{
        boxShadow: "none",
        "&:before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          px: 0,
          ".Mui-expanded": {
            my: 1.5,
          },
        }}
      >
        <Typography variant="subtitle1" fontWeight={700}>
          {header}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ py: 0 }} {...accordionDetailsProps}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
}
